import { render } from "./SetPassword.vue?vue&type=template&id=14be4c28&scoped=true"
import script from "./SetPassword.vue?vue&type=script&lang=ts"
export * from "./SetPassword.vue?vue&type=script&lang=ts"

import "./SetPassword.vue?vue&type=style&index=0&id=14be4c28&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-14be4c28"

export default script